import isEmpty from 'lodash/isEmpty';
import find from 'lodash/find';
import each from 'lodash/each';
import reduce from 'lodash/reduce';
import every from 'lodash/every';
import flatten from 'lodash/flatten';
import { useMemo } from 'react';

function filterQuerylets(value, indexedQuerylets, indexedForms) {
  // index list matcher
  const matchIndexList = (list, query) => find(list, (idx) => idx.indexOf(query.toLowerCase()) !== -1);

  const resultsDbFacts = [];
  let resultsForms = [];

  // search indexed facts
  each(indexedQuerylets, (indexed) => {
    const dbItem = indexed._databaseData;
    let foundFacts = reduce(
      indexed._factsIndexes,
      (acc, indexesByPriority, factId) => {
        every(indexesByPriority, (indexes, priority) => {
          if (matchIndexList(indexes, value)) {
            const factItem = indexed._factsData[factId];

            acc[priority] = acc[priority] || [];
            acc[priority].push(factItem);
            return false;
          }

          return true;
        });

        return acc;
      },
      []
    );
    foundFacts = flatten(foundFacts);

    if (!isEmpty(foundFacts)) {
      resultsDbFacts.push({
        ...dbItem,
        children: foundFacts,
        childrenCount: foundFacts.length,
      });
    }
  });

  // search indexed forms
  resultsForms = reduce(
    indexedForms,
    (acc, indexed) => {
      const formItem = indexed._formData;

      every(indexed._formIndexes, (indexes, priority) => {
        acc[priority] = acc[priority] || [];

        if (matchIndexList(indexes, value)) {
          acc[priority].push(formItem);
          return false;
        }

        return true;
      });

      return acc;
    },
    []
  );
  resultsForms = flatten(resultsForms);

  return [...resultsDbFacts, ...resultsForms];
}

function useSearchQuerylets(value, indexedQuerylets, indexedForms) {
  return useMemo(() => {
    const shouldSearch = value && value.length > 1;
    return [shouldSearch, shouldSearch ? filterQuerylets(value, indexedQuerylets, indexedForms) : []];
  }, [value, indexedQuerylets, indexedForms]);
}

export default useSearchQuerylets;
